export default function Masonry({ children, }: { children: React.ReactNode }) {
  return (
    <div className="columns-2 sm:columns-3 lg:columns-5 2xl:columns-6 w-full gap-px">
      {children}
    </div>
  );
}
